"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRegulatoryAssessmentAbbrDto = instanceOfRegulatoryAssessmentAbbrDto;
exports.RegulatoryAssessmentAbbrDtoFromJSON = RegulatoryAssessmentAbbrDtoFromJSON;
exports.RegulatoryAssessmentAbbrDtoFromJSONTyped = RegulatoryAssessmentAbbrDtoFromJSONTyped;
exports.RegulatoryAssessmentAbbrDtoToJSON = RegulatoryAssessmentAbbrDtoToJSON;
exports.RegulatoryAssessmentAbbrDtoToJSONTyped = RegulatoryAssessmentAbbrDtoToJSONTyped;
const AssessmentStatus_1 = require("./AssessmentStatus");
/**
 * Check if a given object implements the RegulatoryAssessmentAbbrDto interface.
 */
function instanceOfRegulatoryAssessmentAbbrDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('assessmentStatus' in value) || value['assessmentStatus'] === undefined)
        return false;
    return true;
}
function RegulatoryAssessmentAbbrDtoFromJSON(json) {
    return RegulatoryAssessmentAbbrDtoFromJSONTyped(json, false);
}
function RegulatoryAssessmentAbbrDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'name': json['name'],
        'assessmentStatus': (0, AssessmentStatus_1.AssessmentStatusFromJSON)(json['assessmentStatus']),
    };
}
function RegulatoryAssessmentAbbrDtoToJSON(json) {
    return RegulatoryAssessmentAbbrDtoToJSONTyped(json, false);
}
function RegulatoryAssessmentAbbrDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'name': value['name'],
        'assessmentStatus': (0, AssessmentStatus_1.AssessmentStatusToJSON)(value['assessmentStatus']),
    };
}
//# sourceMappingURL=RegulatoryAssessmentAbbrDto.js.map